
export class ILoginModel {
  nomeUtente:string;
  password:string;
  role:number;
}

export class RefreshSIUTokenRequest {
    tokenUtente:string;
    uVRoloil?:string;
    zonaRoloil?:string;
    oldSIUToken?:string;
    
}
export class RefreshSIUTokenResponse {
     siuToken:string ;
     isSIUTokenRenewed:boolean;
     message:string;
}
export class RichiestaZoneUnitaVenditaModel {
  codiceUV?:string;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/account/ilogin.model.ts